var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import QrcodeVue from 'qrcode.vue';
import { InvoiceData } from "../../../lib/invoiceData";
import { WalletsHelper } from "../../../lib/storage";
export default Vue.extend({
    components: { QrcodeVue },
    name: "ReceiveView",
    data() {
        return {
            address: '',
            invoiceData: ''
        };
    },
    computed: {},
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            const activeWallet = yield WalletsHelper.getActive();
            if (activeWallet == null) {
                this.address = '';
            }
            else {
                this.address = activeWallet.address;
            }
            this.invoiceData = new InvoiceData(this.address).toJsonString();
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/top/Receive.vue
// module id = 391
// module chunks = 1